import OfferChip from '@/components/ui/OfferChip';
import Spacer from '@/components/ui/Spacer';
import { Offer, OfferDetails, PostbackReward } from '@/model/offer';
import React from 'react';
import Divider from '../ui/Divider';

/**
 *
 * @param {Object} props
 * @param {Offer} props.offer
 * @param {OfferDetails} props.offerDetails
 * @returns {JSX.Element}
 */

export default function SupportOfferCard({ offer, offerDetails }) {
  let chipVariant;
  if (typeof offer?.isOngoing !== 'function') {
    chipVariant = offer.isOngoing
      ? 'ongoing'
      : offer.isCompleted
      ? 'completed'
      : '';
  } else {
    chipVariant = offer?.isOngoing()
      ? 'ongoing'
      : offer?.isCompleted()
      ? 'completed'
      : '';
  }

  if (offerDetails?.isAnyPostbackLocalVerified() || offer?.isLocalVerified) {
    return (
      <div className="p-5 border rounded-lg border-warning bg-warning-lighten">
        <div className="flex items-center gap-3">
          <img
            src={offer?.iconImage}
            alt={offer?.title}
            className="w-12 h-12 rounded-md"
          />
          <div>
            <p className="font-bold text-ellipsis line-clamp-1">
              {offer?.title}
            </p>
          </div>
          <OfferChip
            containerClass="ml-auto self-start"
            variant={chipVariant}
          />
        </div>
        <Spacer size="large" />
        <Divider />
        <Spacer size="large" />
        <p className="text-sm font-bold">Est. time for reward : 3 days</p>
        <Spacer size="small" />
        <p className="text-sm text-white/60">
          Sometimes advertisers take upto 3 days to verify your reward.
        </p>
        <Spacer />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <img
        src={offer?.iconImage}
        alt={offer?.title}
        className="w-12 h-12 rounded-md"
      />
      <div>
        <p className="font-bold text-ellipsis line-clamp-1">{offer?.title}</p>
      </div>
      <OfferChip containerClass="ml-auto self-start" variant={chipVariant} />
    </div>
  );
}
